<script lang="ts" setup></script>

<template>
  <main>
    <slot />
  </main>
</template>
